<template>
  <transition
      name="unpin-slide"
      @after-leave="afterLeave"
    >
    <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.contact, collapsed: !expanded.contact }">
        <div class="info-card-content">
          <div v-if="!expanded.contact" class="flex flex-row items-center gap-2">
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.7611 6.41665L15.9277 7.24998C17.4277 8.74998 17.4277 11.0833 15.9277 12.6666L16.7611 13.5C18.8444 11.5833 18.8444 8.41665 16.7611 6.41665ZM15.0111 8.16665L14.1777 8.99998C14.5944 9.58331 14.5944 10.3333 14.1777 10.9166L15.0111 11.75C16.0111 10.75 16.0111 9.24998 15.0111 8.16665ZM11.6777 0.833313H3.3444C2.42773 0.833313 1.67773 1.58331 1.67773 2.49998V17.5C1.67773 18.4166 2.42773 19.1666 3.3444 19.1666H11.6777C12.5944 19.1666 13.3444 18.4166 13.3444 17.5V2.49998C13.3444 1.58331 12.5944 0.833313 11.6777 0.833313ZM11.6777 16.6666H3.3444V3.33331H11.6777V16.6666Z" fill="#25B8C2"/>
              </svg>
            </div>
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M8.99935 0.666687C4.39935 0.666687 0.666016 4.40002 0.666016 9.00002C0.666016 13.6 4.39935 17.3334 8.99935 17.3334H13.166V15.6667H8.99935C5.38268 15.6667 2.33268 12.6167 2.33268 9.00002C2.33268 5.38335 5.38268 2.33335 8.99935 2.33335C12.616 2.33335 15.666 5.38335 15.666 9.00002V10.1917C15.666 10.85 15.0743 11.5 14.416 11.5C13.7577 11.5 13.166 10.85 13.166 10.1917V9.00002C13.166 6.70002 11.2993 4.83335 8.99935 4.83335C6.69935 4.83335 4.83268 6.70002 4.83268 9.00002C4.83268 11.3 6.69935 13.1667 8.99935 13.1667C10.1493 13.1667 11.1993 12.7 11.9493 11.9417C12.491 12.6834 13.4243 13.1667 14.416 13.1667C16.0577 13.1667 17.3327 11.8334 17.3327 10.1917V9.00002C17.3327 4.40002 13.5993 0.666687 8.99935 0.666687ZM8.99935 11.5C7.61602 11.5 6.49935 10.3834 6.49935 9.00002C6.49935 7.61669 7.61602 6.50002 8.99935 6.50002C10.3827 6.50002 11.4993 7.61669 11.4993 9.00002C11.4993 10.3834 10.3827 11.5 8.99935 11.5Z" fill="#25B8C2"/>
              </svg>
            </div>
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none">
                <path d="M5.99935 0.666687C2.77435 0.666687 0.166016 3.27502 0.166016 6.50002C0.166016 10.875 5.99935 17.3334 5.99935 17.3334C5.99935 17.3334 11.8327 10.875 11.8327 6.50002C11.8327 3.27502 9.22435 0.666687 5.99935 0.666687ZM1.83268 6.50002C1.83268 4.20002 3.69935 2.33335 5.99935 2.33335C8.29935 2.33335 10.166 4.20002 10.166 6.50002C10.166 8.90002 7.76602 12.4917 5.99935 14.7334C4.26602 12.5084 1.83268 8.87502 1.83268 6.50002Z" fill="#25B8C2"/>
                <path d="M5.99935 8.58335C7.14994 8.58335 8.08268 7.65061 8.08268 6.50002C8.08268 5.34943 7.14994 4.41669 5.99935 4.41669C4.84876 4.41669 3.91602 5.34943 3.91602 6.50002C3.91602 7.65061 4.84876 8.58335 5.99935 8.58335Z" fill="#25B8C2"/>
              </svg>
            </div>
          </div>
          <div v-else class="info-row-group">
            <div class="info-row">
              <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M16.7611 6.41665L15.9277 7.24998C17.4277 8.74998 17.4277 11.0833 15.9277 12.6666L16.7611 13.5C18.8444 11.5833 18.8444 8.41665 16.7611 6.41665ZM15.0111 8.16665L14.1777 8.99998C14.5944 9.58331 14.5944 10.3333 14.1777 10.9166L15.0111 11.75C16.0111 10.75 16.0111 9.24998 15.0111 8.16665ZM11.6777 0.833313H3.3444C2.42773 0.833313 1.67773 1.58331 1.67773 2.49998V17.5C1.67773 18.4166 2.42773 19.1666 3.3444 19.1666H11.6777C12.5944 19.1666 13.3444 18.4166 13.3444 17.5V2.49998C13.3444 1.58331 12.5944 0.833313 11.6777 0.833313ZM11.6777 16.6666H3.3444V3.33331H11.6777V16.6666Z" fill="#25B8C2"/>
                </svg>
              </div>
              <p class="info-text">{{ contactData.phone }}</p>
            </div>
            <div class="info-row">
              <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M8.99935 0.666687C4.39935 0.666687 0.666016 4.40002 0.666016 9.00002C0.666016 13.6 4.39935 17.3334 8.99935 17.3334H13.166V15.6667H8.99935C5.38268 15.6667 2.33268 12.6167 2.33268 9.00002C2.33268 5.38335 5.38268 2.33335 8.99935 2.33335C12.616 2.33335 15.666 5.38335 15.666 9.00002V10.1917C15.666 10.85 15.0743 11.5 14.416 11.5C13.7577 11.5 13.166 10.85 13.166 10.1917V9.00002C13.166 6.70002 11.2993 4.83335 8.99935 4.83335C6.69935 4.83335 4.83268 6.70002 4.83268 9.00002C4.83268 11.3 6.69935 13.1667 8.99935 13.1667C10.1493 13.1667 11.1993 12.7 11.9493 11.9417C12.491 12.6834 13.4243 13.1667 14.416 13.1667C16.0577 13.1667 17.3327 11.8334 17.3327 10.1917V9.00002C17.3327 4.40002 13.5993 0.666687 8.99935 0.666687ZM8.99935 11.5C7.61602 11.5 6.49935 10.3834 6.49935 9.00002C6.49935 7.61669 7.61602 6.50002 8.99935 6.50002C10.3827 6.50002 11.4993 7.61669 11.4993 9.00002C11.4993 10.3834 10.3827 11.5 8.99935 11.5Z" fill="#25B8C2"/>
                </svg>
              </div>
              <p class="info-text">{{ contactData.email }}</p>
            </div>
            <div class="info-row">
              <div class="icon-container" style="width: 24px; height: 24px">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 12 18" fill="none">
                  <path d="M5.99935 0.666687C2.77435 0.666687 0.166016 3.27502 0.166016 6.50002C0.166016 10.875 5.99935 17.3334 5.99935 17.3334C5.99935 17.3334 11.8327 10.875 11.8327 6.50002C11.8327 3.27502 9.22435 0.666687 5.99935 0.666687ZM1.83268 6.50002C1.83268 4.20002 3.69935 2.33335 5.99935 2.33335C8.29935 2.33335 10.166 4.20002 10.166 6.50002C10.166 8.90002 7.76602 12.4917 5.99935 14.7334C4.26602 12.5084 1.83268 8.87502 1.83268 6.50002Z" fill="#25B8C2"/>
                  <path d="M5.99935 8.58335C7.14994 8.58335 8.08268 7.65061 8.08268 6.50002C8.08268 5.34943 7.14994 4.41669 5.99935 4.41669C4.84876 4.41669 3.91602 5.34943 3.91602 6.50002C3.91602 7.65061 4.84876 8.58335 5.99935 8.58335Z" fill="#25B8C2"/>
                </svg>
              </div>
              <p class="info-text">{{ contactData.address }}</p>
            </div>
          </div>
          <div v-if="expanded.contact" class="action-icons">
            <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
              <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
            </div>
            <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
              <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
            </div>
            <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('contact')">
              <img src="@/assets/cardActions/collapse.svg" alt="Collapse" />
            </div>
          </div>
          <div v-else class="flex flex-row items-center gap-2">
            <div class="action-icon" @click.stop="toggleCard('contact')">
              <img src="@/assets/cardActions/expand.svg" alt="Expand" />
            </div>
            <div class="action-icon" @click.stop="toggleCard('contact')">
              <img src="@/assets/cardActions/move.svg" alt="Move" />
            </div>
          </div>
        </div>
        <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
          <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
            <template #prefix>
              <img src="@/assets/cardActions/move.svg" alt="Move" />
            </template>
          </FoldableButton>
          <div class="flex flex-row gap-1 justify-end">
            <FoldableButton text="Edit" @click="handleEdit">
              <template #prefix>
                <img src="@/assets/cardActions/edit.svg" alt="Edit" />
              </template>
            </FoldableButton>
            <FoldableButton text="Variable Properties" @click="handleVariableProperties">
              <template #prefix>
                <img src="@/assets/cardActions/pt_variable.svg" alt="Variable Properties" />
              </template>
            </FoldableButton>
          </div>
        </div>
      </div>
  </transition>

  <PatientVariableDialog
    v-model:visible="showPtVariablesDialog"
    :ptVariables="ptVariables"
    :patientId="patientId"
  />
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { mapGetters } from 'vuex'
import { useCardActions } from '@/composables/useCardActions';
import { useMyPatientsStore } from '@/store/helpers';
import PatientVariableDialog from './PatientVariableDialog.vue';

const ptVariables = ['pt_phone', 'pt_email', 'pt_address']
const showPtVariablesDialog = ref(false)

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
  cardData: {
    type: Object,
    default: () => ({})
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  externalVariableDialog: {
    type: Boolean,
    default: false,
  },
});

// Define emits
const emit = defineEmits(['unpin-card', 'pin-card', 'edit-contact', 'open-variable-dialog']);

const store = useStore();
const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);

const isLeaving = ref(false);

const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};


// This is called after the leave animation finishes
const afterLeave = () => {
  emit('unpin-card', props.cardData); // parent removes the card
};

const expanded = ref({
  contact: true,
})

const toggleCard = (cardType) => {
  expanded.value[cardType] = !expanded.value[cardType]
}

const handleEdit = () => {
  emit('edit-contact')
}

const handleVariableProperties = () => {
  if (!props.externalVariableDialog) {
    showPtVariablesDialog.value = true;
  }
  emit('open-variable-dialog', ptVariables);
};

const patientId = computed(() => {
  const room = store.getters['myPatients/rooms/getPatientByRoomId'](props.patient);
  return room?.patientBasicInfo?.patientId || props.patient || '';
});

// Get contact data — try rooms store first, fallback to backendusers
const contactData = computed(() => {
  const room = store.getters['myPatients/rooms/getPatientByRoomId'](props.patient);
  if (room?.patientBasicInfo) {
    const patient = room.patientBasicInfo;
    return {
      phone: patient.phone || 'Not Provided',
      email: patient.email || 'Not Provided',
      address: patient.address || 'Not Provided',
      preferredContact: 'Not Provided'
    };
  }

  // Fallback: backendusers store (encounter notes context)
  const backendUser = store.state.myPatients?.patientInfo?.backendusers?.[props.patient];
  if (backendUser) {
    const contacts = backendUser.patient_contact || [];
    const phoneContact = contacts.find(c => c.contact_type === 'phone');
    const emailContact = contacts.find(c => c.contact_type === 'email');
    const phone = phoneContact?.contact_details || backendUser.patient_telephone || '';
    const email = emailContact?.contact_details || backendUser.patient_email || '';

    const addr = backendUser.patient_address;
    const addressStr = Array.isArray(addr) && addr.length > 0
      ? [addr[0].street_address, addr[0].city, addr[0].state, addr[0].zipcode, addr[0].country].filter(Boolean).join(', ')
      : (typeof addr === 'string' ? addr : '');
    return {
      phone: phone || 'Not Provided',
      email: email || 'Not Provided',
      address: addressStr || 'Not Provided',
      preferredContact: 'Not Provided'
    };
  }

  return { phone: 'Not Provided', email: 'Not Provided', address: 'Not Provided', preferredContact: 'Not Provided' };
})


</script>


<style scoped>

/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #c4c4c4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              padding-bottom 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #c4c4c4);
  pointer-events: auto;
}

.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}

.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.peg-board-title {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 16px;
}

.peg-board-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  padding: 0 8px;
}

.info-card {
  background-color: white;
  border-radius: 5px;
  padding: 12px 16px;
  box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.info-card-content-col-group {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
}

.info-row-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.icon-container {
  background-color: #f2f2f2;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-style {
  width: 20px;
  height: 20px;
}

.info-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  line-height: 20px;
  flex: 1;          /* take available space */
  min-width: 0;     /* prevent overflow cutoff in flexbox */
  white-space: normal; /* allow wrapping */
  word-break: break-word; 
}

.action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.appointment-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50px;
  height: 64px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
  overflow: hidden;
}

.month {
  background-color: #004879;
  color: white;
  width: 100%;
  text-align: center;
  padding: 2px 0;
  font-size: 14px;
}

.day {
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  text-transform: capitalize;
  height: 24px;
}

.weekday {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1;
  padding-bottom: 3px;
}

.appointment-details {
    flex-grow: 1;
}

.detail-title {
    font-size: 12px;
    color: #666;
}
.detail-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}
.action-icons-appointment {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 20px;
}
.info-text-title {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #666;
}
.info-text-large {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

/* Badge for billing preference */
.badge {
  color: #25B8C2;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
  letter-spacing: 0.25px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.badge-default {
  border-radius: 20px;
  background: #EBFFF8;
  width: 68px;
}

.expand-action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1B79A0;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 5px;
}

.expand-action span {
  color: var(--color-Darkblue-000, #1E4670);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

/* Icon-only buttons with hover text reveal */
.copy-expand,
.edit-expand,
.variable-expand,
.move-expand {
  display: flex;
  align-items: center;
  width: 26px;
  overflow: hidden;
  padding: 4px;
  justify-content: center;
  transition: width 0.25s ease, padding 0.25s ease, gap 0.25s ease;
  gap: 0;
}

.copy-expand:hover,
.edit-expand:hover,
.variable-expand:hover,
.move-expand:hover {
  padding: 4px 10px;
  justify-content: flex-start;
  gap: 6px;
}

.copy-expand:hover { width: 74px; }
.edit-expand:hover { width: 74px; }
.move-expand:hover { width: 78px; }
.variable-expand:hover { width: 168px; }
.copy-expand span,
.edit-expand span,
.variable-expand span,
.move-expand span {
  white-space: nowrap;
  opacity: 0;
  min-width: 0;
  transition: opacity 0.2s ease;
  transition-delay: 0.05s;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1E4670;
  text-decoration: underline;
}

.copy-expand:hover span,
.edit-expand:hover span,
.variable-expand:hover span,
.move-expand:hover span {
  opacity: 1;
}

.copy-expand img,
.edit-expand img,
.variable-expand img,
.move-expand img {
  flex-shrink: 0;
}

.action-icon {
  width: 28px;          /* w-7 */
  height: 28px;         /* h-7 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;   /* rounded-[5px] */
  padding: 5px;         /* pd-5 (assuming you meant padding) */
  cursor: pointer;
  transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover,
.expand-action:hover {
  background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}
</style>
